import { gql } from "@apollo/client";


export const MY_REPOS_QUERY = gql`

  query MyRepos($portalUserId: Int!) {
    myRepos(portalUserId: $portalUserId) {
      id
      product_id
      product_name
      model_num
      version
      arch
      repo_path
      repo_url
    }
  }
`;

export const REPO_CONTENTS_QUERY = gql`
  query RepoContents(
    $portalUserId: Int!
    $productId: Int!
    $subPath: String
  ) {
    repoContents(
      portalUserId: $portalUserId
      productId: $productId
      subPath: $subPath
    ) {
      name
      type
      size
      modifiedAt
    }
  }
`;